module.exports = __webpack_public_path__ + "media/images/icons/facebook_blue-ae116d6c07153a1d6395a1a549fec2c8.svg";